export const ERROR_REQUEST_TIMED_OUT = 'Request timed out';
